import { dataHooks } from '@wix/data-hooks';

export const subHeaderDataHooks = dataHooks<{
  subtitle: {};
  title: {};
  description: {};
  signupLink: {};
}>('sub-header');
